import { render, staticRenderFns } from "./BalaSearch.vue?vue&type=template&id=469a498f&scoped=true"
import script from "./BalaSearch.vue?vue&type=script&lang=js"
export * from "./BalaSearch.vue?vue&type=script&lang=js"
import style0 from "./BalaSearch.vue?vue&type=style&index=0&id=469a498f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469a498f",
  null
  
)

export default component.exports